import { FORMIK_EMPTY_VALUE } from '../../../../constants/validation'

export const REGISTRATION_FORM_SERVER_ERROR_USER_ALREADY_EXISTS =
  'User_with_specified_email_already_exists'

export const REGISTRATION_FORM_SERVER_NON_FIELD_ERRORS = {
  [REGISTRATION_FORM_SERVER_ERROR_USER_ALREADY_EXISTS]:
    'Error.AuthRegistrationFormUserAlreadyExistsKey',
}

export const REGISTRATION_FORM_FIELD_NAME_BUILDING = 'building'

export const REGISTRATION_FORM_FIELD_NAME_EMAIL = 'email'

export const REGISTRATION_FORM_FIELD_NAME_FIRST_NAME = 'firstName'

export const REGISTRATION_FORM_FIELD_NAME_FLAT = 'flat'

export const REGISTRATION_FORM_FIELD_NAME_LAST_NAME = 'lastName'

export const REGISTRATION_FORM_INITIAL_VALUES = {
  [REGISTRATION_FORM_FIELD_NAME_BUILDING]: null,
  [REGISTRATION_FORM_FIELD_NAME_EMAIL]: FORMIK_EMPTY_VALUE,
  [REGISTRATION_FORM_FIELD_NAME_FIRST_NAME]: FORMIK_EMPTY_VALUE,
  [REGISTRATION_FORM_FIELD_NAME_FLAT]: null,
  [REGISTRATION_FORM_FIELD_NAME_LAST_NAME]: FORMIK_EMPTY_VALUE,
}

export const REGISTRATION_FORM_FIRST_NAME_MAX_LENGTH = 160

export const REGISTRATION_FORM_LAST_NAME_MAX_LENGTH = 160

export const REGISTRATION_FORM_EMAIL_MAX_LENGTH = 128

export const REGISTRATION_FORM_FLAT_MAX_LENGTH = 255

export const REGISTRATION_FORM_FIELD_HEIGHT = 48
